import { render, staticRenderFns } from "./SaveConfirmDialog.vue?vue&type=template&id=0ca4697a&scoped=true&"
import script from "./SaveConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./SaveConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./SaveConfirmDialog.vue?vue&type=style&index=0&id=0ca4697a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4697a",
  null
  
)

export default component.exports